import { render, staticRenderFns } from "./ReceiptPrinter.vue?vue&type=template&id=559e2848"
import script from "./ReceiptPrinter.vue?vue&type=script&lang=js"
export * from "./ReceiptPrinter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports